import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from 'lib'

type Params = {
  proposalId: string
}

export type AutentiqueResponse = {
  id: string
  signed: boolean
  linkToSign: string
  files: {
    original: string
    signed: string
  }
  createdAt: string
}

const loadAutentiqueSignedProposals = (
  params: Params
): Promise<AutentiqueResponse[]> => {
  return axios.post(
    `/autentique/proposal/${params.proposalId}/documents`,
    params
  )
}

export function useLoadAutentiqueSignedProposals(params: Params) {
  return useQuery(
    ['loadAutentiqueSignedProposals', params],
    () => loadAutentiqueSignedProposals(params),
    {
      enabled: !!params?.proposalId,
      keepPreviousData: true,
      onError: () =>
        toast.error(
          'Não foi possível carregar os documentos assinados pelo autentique',
          {
            toastId: 'loadAutentiqueSignedProposals'
          }
        )
    }
  )
}
